export default __webpack_public_path__ + "static/media/disaster-prevention.25484b44.png";